import React, { ComponentProps } from 'react';

import PropTypes from 'prop-types';

import { IconButton } from '@adsk/alloy-react-button';
import { XIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import { stylePropType } from '@adsk/alloy-react-theme';

/**
 * Close Button.
 */
const CloseButton = React.forwardRef<
  HTMLButtonElement,
  ComponentProps<typeof IconButton> & {
    showEscapeLabel?: boolean;
  }
>(
  (
    {
      style,
      children,
      disabled = false,
      showEscapeLabel = true,
      type = 'button',
      renderIcon = XIcon.renderIcon,
      ...props
    },
    ref,
  ) => {
    const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

    const label = showEscapeLabel
      ? T.translate('CLOSE_ESC')
      : T.translate('CLOSE');

    return (
      <IconButton
        ref={ref}
        aria-label={label?.toString()}
        style={style}
        data-testid="close-button"
        disabled={disabled}
        type={type}
        renderIcon={renderIcon}
        {...props}
      />
    );
  },
);

CloseButton.displayName = 'CloseButton';

CloseButton.propTypes = {
  /** BasicButton's content */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** button html type, eg: submit */
  type: IconButton.propTypes?.type,
  /** Disable button functionality */
  disabled: PropTypes.bool,
  /** handle onclick event for button */
  onClick: PropTypes.func,
  /** Modify tooltip if Esc will be used to close */
  showEscapeLabel: PropTypes.bool,
};

export default CloseButton;
